import { RouteComponentProps } from "react-router-dom";
import { RequirementsDetailsRoute } from "./RequirementsDetailsRoute";
import { WSPage } from "@wingspanhq/fe-component-library";
import { WSQueries } from "../../../../query/WSQuery";
import { useQueryPayer } from "../../../../query/payers/queries/useQueryPayer";
import { useQueryRequirement } from "../../../../query/requirements/queries/useQueryRequirement";

export const RouteRequirementDetails: React.FC<
  RouteComponentProps<{
    payerId: string;
    requirementId: string;
  }>
> = ({
  match: {
    params: { requirementId, payerId }
  }
}) => {
  const queryPayer = useQueryPayer(payerId);
  const queryRequirement = useQueryRequirement(requirementId);

  return (
    <WSPage>
      <WSQueries
        queries={{
          queryPayer,
          queryRequirement
        }}
      >
        {({ queryPayerData, queryRequirementData }) => {
          return (
            <RequirementsDetailsRoute
              payer={queryPayerData}
              requirement={queryRequirementData}
            />
          );
        }}
      </WSQueries>
    </WSPage>
  );
};
